import { render, staticRenderFns } from "./TowerMenu.vue?vue&type=template&id=35c56492&"
import script from "./TowerMenu.vue?vue&type=script&lang=js&"
export * from "./TowerMenu.vue?vue&type=script&lang=js&"
import style0 from "./TowerMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports